import { useState } from 'react';
import { createOrg } from '../api';
import { setOrgId } from '../auth';

export default function OrgSetup({ onComplete }) {
  const [form, setForm] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handle = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const org = await createOrg(form);
      setOrgId(org.orgId);
      onComplete(org);
    } catch (err) {
      setError(err.message || 'Failed to create organization');
    } finally { setLoading(false); }
  };

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div className="login-page">
      <div className="login-box" style={{ maxWidth: 460 }}>
        <div className="logo">
          <div style={{ fontSize: 40 }}>🏢</div>
          <h2>Set Up Your Organization</h2>
          <p>This is the top-level container for all your teams and projects. You can invite co-managers later.</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handle}>
          <div className="form-group">
            <label>Organization Name</label>
            <input value={form.name} onChange={set('name')} required autoFocus
              placeholder="e.g. Detroit Hockey Club, Riverside Youth Soccer" />
            <div className="helper-text">This is the name your co-managers will see.</div>
          </div>
          <div className="form-group">
            <label>Description (optional)</label>
            <textarea value={form.description} onChange={set('description')} rows={2}
              placeholder="Brief description of your organization…" />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={loading}>
            {loading ? 'Creating…' : 'Create Organization →'}
          </button>
        </form>
      </div>
    </div>
  );
}
